// import axios from "axios";
import apiCall from "@/store/utils/api";

const actions = {
	getAddressesByAddress({ commit }, search) {
		commit("SET_DIDSEARCH", false);
		commit("SET_ISLOADING", true);
		apiCall
			.get(`/api/v1/properties/search?address=${search}`)
			.then((data) => {
				console.log(data);
				const posts = data;
				commit("SET_RESULTS", posts);
				commit("SET_DIDSEARCH", true);
				commit("SET_ISLOADING", false);
			})
			.catch((error) => {
				commit("SET_ISLOADING", false);
				console.log(error);
			});
	},
	getAddressesByPin({ commit }, pinSearch) {
		commit("SET_DIDSEARCH", false);
		commit("SET_ISLOADING", true);
		apiCall
			.get(`/api/v1/properties/search?pin=${pinSearch}`)
			.then((data) => {
				console.log(data);
				const posts = data;
				commit("SET_RESULTS", posts);
				commit("SET_DIDSEARCH", true);
				commit("SET_ISLOADING", false);
			})
			.catch((error) => {
				commit("SET_ISLOADING", false);
				console.log(error);
			});
	},
	getAddressesByAny({ dispatch }, search) {
		if (/^\d+$/.test(search.replace(/-/g, "")) && search.length > 10) {
			console.log("PIN detected");
			dispatch("getAddressesByPin", search);
		} else {
			console.log("ADDRESS detected");
			dispatch("getAddressesByAddress", search);
		}
	},
};

export default actions;
